export default "__VITE_ASSET__DmRiD6PD__"